// @flow

import type { DispatchAPI, MiddlewareAPI } from 'redux';

import type { Action, State } from 'app/common/types';
import { type StateMachineRegistry } from 'app/common/StateMachines';

export const createMiddleware = (registry: StateMachineRegistry) => {
  return (store: MiddlewareAPI<State, Action, DispatchAPI<Action>>) => (
    next: DispatchAPI<Action>
  ) => (action: Action) => {
    const result = next(action);
    registry.process(store.getState, action);
    return result;
  };
};
